// extracted by mini-css-extract-plugin
export var orderSummary = "_qr-0";
export var showMoreLessButton = "_qr-1";